const bodyLock = () => {
  let body = document.body;
  if (body.classList.contains('lock')) return;

  scrollPosition = window.pageYOffset;
  body.classList.add('lock');
  body.style.top = `-${scrollPosition}px`;
}

global.bodyLock = bodyLock;

const bodyUnlock = () => {
  let body = document.body;
  if (!body.classList.contains('lock')) return;

  body.classList.remove('lock');
  body.style.removeProperty('top');
  window.scrollTo(0, scrollPosition);
}

global.bodyUnlock = bodyUnlock;

const bodyLockToggle = () =>
  document.body.classList.contains('lock') ? bodyUnlock() : bodyLock();

global.bodyLockToggle = bodyLockToggle;

const menuOpen = () => {
  bodyLock();
  document.documentElement.classList.add('menu-open');
}

global.menuOpen = menuOpen;

const menuClose = () => {
  bodyUnlock();
  document.documentElement.classList.remove('menu-open');
}

global.menuClose = menuClose;

const sendRequest = async (method, url, body) => {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(body)
  };

  const res = await fetch(url, options);
  if (!res.ok) {
    return res.json();
  }
  return res.json();
};

global.sendRequest = sendRequest;

const showNotify = ({ status, message }) => {
  const wrapper = document.querySelector('.notify-wrapper');
  if (!wrapper) return;

  const notifyBody = document.createElement('div');
  notifyBody.classList.add('notify-body');
  const notify = document.createElement('div');
  notify.classList.add('notify', status);
  notify.innerHTML = message;

  notifyBody.append(notify);
  wrapper.append(notifyBody);

  setTimeout(() => {
    notifyBody.remove();
  }, 2000);
};

global.showNotify = showNotify;

const gotoBlock = (targetSelector, noHeader = false, offsetTop = 0) => {
  const targetElement = document.querySelector(targetSelector);
  if (!targetElement) return null;

  let headerElement = null;
  let headerHeight = 0;

  if (noHeader) {
    headerElement = document.querySelector('header.header');
    if (headerElement) {
      const hadScrollClass = headerElement.classList.contains('_header-scroll');

      if (!hadScrollClass) {
        headerElement.style.transitionDuration = '0s';
        headerElement.classList.add('_header-scroll');
      }

      headerHeight = headerElement.offsetHeight;

      if (!hadScrollClass) {
        headerElement.classList.remove('_header-scroll');
        setTimeout(() => {
          headerElement.style.transitionDuration = '';
        }, 0);
      }
    }
  }

  if (document.documentElement.classList.contains('menu-open')) {
    window.menuClose();
  }

  const targetY = targetElement.getBoundingClientRect().top +
    window.scrollY -
    (headerHeight + offsetTop);

  window.scrollTo({
    top: targetY,
    behavior: 'smooth',
  });

  return targetElement;
};

global.gotoBlock = gotoBlock;

const handleViewDetect = (entries, observer) => {
  entries.forEach((entry) => {
    const el = entry.target;
    if (!el) return;

    if (entry.isIntersecting) {
      el.classList.remove('in-view-detect');
      el.classList.add('in-view');

      observer?.unobserve(el);
    }
  });
};

const initViewDetection = ({ selector, threshold = 0.01 } = {}) => {
  const items = document.querySelectorAll(selector);
  if (!items.length) return;

  const observer = new IntersectionObserver(handleViewDetect, { threshold });

  items.forEach(item => observer.observe(item));
  return observer;
};

global.initViewDetection = initViewDetection;

const initAnchors = ({ selector } = {}) => {
  const anchors = document.querySelectorAll(selector);
  if (!anchors.length) return;

  anchors.forEach(anchor => {
    const hash = anchor.hash;
    if (!hash) return;

    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      anchor.blur();

      gotoBlock(hash, true);
    });
  });
}

global.initAnchors = initAnchors;

const validate = (data, rules) => {
  const errors = {};
  removeErrors();

  for (const field in rules) {
    const value = data[field];
    const fieldRules = rules[field];

    for (const rule in fieldRules) {
      if (rule === 'required') {
        if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
          errors[field] = fieldRules[rule];
          break;
        }
      }

      if (rule === 'email') {
        const regex = /^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,64}$/;
        if (typeof value === 'string' && !regex.test(value)) {
          errors[field] = fieldRules[rule];
          break;
        }
      }
    }
  }

  addErrors(errors);
  return errors;
}

global.validate = validate;

const addErrors = (errors) => {
  for (let fieldName in errors) {
    const field = document.querySelector(`[name="${fieldName}"]`);
    if (!field) continue;

    field.classList.add('is-error');
    field.removeEventListener('input', handleFieldChange);
    field.addEventListener('input', handleFieldChange, { once: true });
  }
}

const removeErrors = (fields) => {
  const elements = fields instanceof Element ? [fields] : fields ?? document.querySelectorAll('.is-error');

  elements.forEach((field) => field.classList.remove('is-error'));
}

function handleFieldChange(ev) {
  const field = ev.target;
  removeErrors(field);
  field.removeEventListener('input', handleFieldChange);
}

